import { AreaNotification, useNotifications } from "@relode/core";
import * as React from "react";

export const RouteNotFound = () => {
    const { actions: notifications } = useNotifications();

    React.useEffect(() => {
        notifications.showArea(
            "info",
            "This is not the page you are looking for...",
            "nothingToSeeArea",
            { canClose: false }
        );

        return () => notifications.closeAreaNotification("nothingToSeeArea");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <AreaNotification areaName="nothingToSeeArea" />;
};
